import type { Usuario } from '../api/tipos';

/**
 * Para onde mandar a conta depois de entrar.
 *
 * ADMIN cai direto na administração: quem opera o SaaS não vem baixar XML, e
 * passar pelo painel de cliente antes só adiciona um clique e a dúvida de qual
 * dos dois está aberto. O painel de cliente continua acessível pelo link
 * "Voltar ao meu painel" — o desvio é o padrão, não um bloqueio.
 *
 * Existe como função em vez de espalhar `role === 'ADMIN' ? … : …` porque são
 * quatro pontos de navegação, e um deles esquecido devolve a conta de
 * administração ao painel errado sem ninguém notar.
 */
export function rotaInicial(usuario: Pick<Usuario, 'role'> | null): string {
  return usuario?.role === 'ADMIN' ? '/admin' : '/painel';
}
